// ratingStars.js
import $ from "jquery";
import { initRatingStarsList } from '../../modules/rating.inline';

$(document).ready(function (){
   initRatingStarsList();
});


// WEBPACK FOOTER //
// ./blocks/rating-stars-list-inline/rating-stars-inline.js